import { Component, inject } from '@angular/core';
import { PeriodTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PeriodTypeCreateDto,
  PeriodTypeDto,
  PeriodTypeExcelDownloadDto,
  PeriodTypeUpdateDto,
} from '../proxy/controlling/dtos/period-type';
import { PERIODTYPE_CONFIG, PERIODTYPE_FIELDS } from './period-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-period-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PeriodTypeService, ConfirmationService],
  templateUrl: './period-type.html',
  styleUrl: './period-type.scss',
})
export class PeriodType extends BaseCrudComponent<
  PeriodTypeDto,
  PeriodTypeCreateDto,
  PeriodTypeUpdateDto,
  PeriodTypeExcelDownloadDto
> {
  service = inject(PeriodTypeService);
  config = PERIODTYPE_CONFIG;
  fields = PERIODTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PeriodTypeDto): PeriodTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PeriodType';
  }
}
